let chatMessages = [];
let updateInterval;
let selectedFiles = [];
let currentChatId = null;

// Добавляем HTML для модального окна в начало body
document.body.insertAdjacentHTML('afterbegin', `
    <div class="chat-image-modal" style="display: none;">
        <div class="chat-image-modal__overlay"></div>
        <div class="chat-image-modal__content">
            <img src="" alt="Preview">
            <button class="chat-image-modal__close">&times;</button>
        </div>
    </div>
`);

document.body.insertAdjacentHTML('afterbegin', `
    <div class="chat-error-modal" style="display: none;">
        <div class="chat-error-modal__overlay"></div>
        <div class="chat-error-modal__content">
            <div class="chat-error-modal__message">
                Ошибка. Необходимо ввести текст комментария для отправки файла
            </div>
            <button class="chat-error-modal__ok">Ок</button>
        </div>
    </div>
`);

// Добавляем стили для модального окна
const style = document.createElement('style');
style.textContent = `
    .chat-image-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        display: none;
    }
    
    .chat-image-modal__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
    }
    
    .chat-image-modal__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 90%;
        max-height: 90%;
    }
    
    .chat-image-modal__content img {
        max-width: 100%;
        max-height: 90vh;
        object-fit: contain;
    }
    
    .chat-image-modal__close {
        position: absolute;
        top: -40px;
        right: 0;
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        cursor: pointer;
        padding: 5px;
    }
    
    .chat__message-image img {
        cursor: pointer;
        transition: opacity 0.2s;
    }
    
    .chat__message-image img:hover {
        opacity: 0.8;
    }

    /* Стили для медиа-контента */
    .chat__message-files {
        margin-top: 8px;
        width: 100%;
    }

    .chat__message-file {
        margin: 4px 0;
        max-width: 100%;
    }

    .chat__message-image {
        width: 100%;
        max-width: 250px;
    }

    .chat__message-image img {
        width: 100%;
        height: auto;
        border-radius: 10px;
        object-fit: contain;
    }

    .chat__message-video {
        width: 100%;
        max-width: 250px;
    }

    .chat__message-video video {
        width: 100%;
        height: auto;
        border-radius: 10px;
    }

    .chat__message-audio {
        width: 100%;
        max-width: 250px;
    }

    .chat__message-audio audio {
        width: 100%;
    }

    .chat__message-file a {
        display: flex;
        align-items: center;
        padding: 8px;
        background: #fff;
        border-radius: 8px;
        text-decoration: none;
        color: #222631;
    }

    .chat__message-file .file-icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
    }

    .chat__message-file span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 180px;
    }

    .chat__message--manager .chat__message-file a {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
    }
`;
document.head.appendChild(style);

const errorModalStyle = document.createElement('style');
errorModalStyle.textContent = `
    .chat-error-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        display: none;
    }
    
    .chat-error-modal__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }
    
    .chat-error-modal__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 20px;
        border-radius: 8px;
        text-align: center;
        max-width: 90%;
        width: 400px;
    }
    
    .chat-error-modal__message {
        margin-bottom: 20px;
        color: #333;
    }
    
    .chat-error-modal__ok {
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 24px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
    }
    
    .chat-error-modal__ok:hover {
        background: #0056b3;
    }
`;
document.head.appendChild(errorModalStyle);

function showErrorModal() {
    const modal = document.querySelector('.chat-error-modal');
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
}

function closeErrorModal() {
    const modal = document.querySelector('.chat-error-modal');
    modal.style.display = 'none';
    document.body.style.overflow = '';
}

// Функция для установки ID чата извне
function setChatId(chatId) {
    const chatIdInput = document.getElementById('chatId');
    if (chatIdInput) {
        chatIdInput.value = chatId;
        // Создаем и вызываем событие change
        const event = new Event('change');
        chatIdInput.dispatchEvent(event);
    }
}

function openImageModal(src) {
    const modal = document.querySelector('.chat-image-modal');
    const modalImg = modal.querySelector('img');
    modalImg.src = src;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
}

// Модифицируем функцию initChat
function initChat() {

    const chatElement = document.querySelector('.complains-status__chat');
    const chatIdInput = document.getElementById('chatId');

    if (!chatElement) {
        return;
    }

    if (!chatIdInput) {
        return;
    }

    // Обработчик изменения ID чата
    chatIdInput.addEventListener('change', function() {
        const newChatId = this.value.trim();
        if (newChatId && newChatId !== currentChatId) {  // Проверяем, изменился ли ID
            currentChatId = newChatId;
            stopAutoUpdate(); // Останавливаем предыдущее обновление
            loadInitialMessages()
                .then(() => {
                    setupEventListeners(chatElement, currentChatId);
                    startAutoUpdate();
                });
        }
    });

    // Если в инпуте есть значение при загрузке страницы
    if (chatIdInput.value.trim()) {
        currentChatId = chatIdInput.value.trim();
        loadInitialMessages()
            .then(() => {
                setupEventListeners(chatElement, currentChatId);
                startAutoUpdate();
            });
    } else {
        console.log('ID чата не установлен в инпуте');
    }
}

// Экспортируем функцию установки ID чата в глобальную область видимости
window.setChatId = setChatId;

function closeImageModal() {
    const modal = document.querySelector('.chat-image-modal');
    modal.style.display = 'none';
    document.body.style.overflow = '';
}

// function initChat() {
//     console.log('Инициализация чата...');
//     const chatElement = document.querySelector('.complains-status__chat');
//     if (!chatElement) {
//         console.error('Элемент чата не найден');
//         return;
//     }
//
//     loadInitialMessages()
//         .then(() => {
//             if (currentChatId) {
//                 setupEventListeners(chatElement, currentChatId);
//                 startAutoUpdate(currentChatId);
//             } else {
//                 console.error('Не удалось получить chatId из сообщений');
//             }
//         });
// }

function setupEventListeners(chatElement, chatId) {
    const sendButton = chatElement.querySelector('.chat__send-btn');
    const input = chatElement.querySelector('.chat__input input');
    const fileButton = chatElement.querySelector('.chat__file-btn');
    const fileInput = createFileInput(chatElement, fileButton);

    sendButton.addEventListener('click', () => handleSendMessage(input, chatId));
    input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            handleSendMessage(input, chatId);
        }
    });

    // Добавляем обработчики для модального окна
    document.querySelector('.chat-image-modal__close').addEventListener('click', closeImageModal);
    document.querySelector('.chat-image-modal__overlay').addEventListener('click', closeImageModal);
    document.querySelector('.chat-image-modal__content img').addEventListener('click', (e) => {
        e.stopPropagation();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeImageModal();
        }
    });
}

function createFileInput(chatElement, fileButton) {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.style.display = 'none';
    chatElement.appendChild(fileInput);

    fileInput.addEventListener('change', (e) => {
        selectedFiles = Array.from(e.target.files);
        fileButton.textContent = selectedFiles.length || '+';
    });

    fileButton.addEventListener('click', () => fileInput.click());
    return fileInput;
}

function handleSendMessage(input, chatId) {
    const text = input.value.trim();

    // Check if there are files selected but no text
    if (selectedFiles.length > 0 && !text) {
        showErrorModal();
        return;
    }

    if (text || selectedFiles.length > 0) {
        sendMessage(text, chatId);
    }
}

function loadInitialMessages() {
    console.log('Загрузка начальных сообщений...');
    return fetch(`/api/loadMessages.php${currentChatId ? `?chatId=${currentChatId}` : ''}`)
        .then(response => response.json())
        .then(response => {
            console.log('Получены сообщения:', response);

            if (!response.data || !Array.isArray(response.data)) {
                console.error('Получены некорректные данные:', response);
                return;
            }

            chatMessages = response.data;
            renderMessages(response.data);
        })
        .catch(error => {
            console.error('Ошибка при загрузке сообщений:', error);
        });
}

function renderMessages(messages) {
    if (!Array.isArray(messages)) {
        console.error('renderMessages: получен не массив:', messages);
        return;
    }

    const messagesContainer = document.querySelector('.chat__messages');
    if (!messagesContainer) {
        console.error('Не найден контейнер сообщений');
        return;
    }

    const chatTitle = messagesContainer.querySelector('.chat__title');
    messagesContainer.innerHTML = '';

    if (chatTitle) {
        messagesContainer.appendChild(chatTitle);
    }

    messages.forEach(message => {
        if (!message) {
            console.error('Получено пустое сообщение');
            return;
        }

        const isCurrentUser = message.from === 'client';
        const hasAttachments = message.attachments && message.attachments.length > 0;

        const messageHTML = `
            <div class="chat__message ${isCurrentUser ? 'chat__message--user' : 'chat__message--manager'}" 
                 data-message-id="${message.id}"
                 data-chat-id="${message.chatId}">
                ${isCurrentUser ?
            `<img src="../../img/profile-pic-1.svg" alt="" class="profile-pic">
                     <div class="chat__message-wrapper">
                         <span class="chat__message-author-user">Я</span>` :
            `<div class="chat__message-wrapper-manager">
                         <span class="chat__message-author-manager">${message.name}</span>`
        }
                <span class="chat__message-text">${message.text || ''}</span>
                ${hasAttachments ?
            `<div class="chat__message-files">
                        ${message.attachments.map(file => {
                const fileExt = file.name.split('.').pop().toLowerCase();

                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExt)) {
                    return `
                                    <div class="chat__message-file chat__message-image">
                                        <img src="${file.src}" alt="${file.name}" loading="lazy">
                                    </div>`;
                }

                if (['mp4', 'webm', 'ogg'].includes(fileExt)) {
                    return `
                                    <div class="chat__message-file chat__message-video">
                                        <video controls>
                                            <source src="${file.src}" type="video/${fileExt}">
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>`;
                }

                if (['mp3', 'wav', 'ogg'].includes(fileExt)) {
                    return `
                                    <div class="chat__message-file chat__message-audio">
                                        <audio controls>
                                            <source src="${file.src}" type="audio/${fileExt}">
                                            Your browser does not support the audio element.
                                        </audio>
                                    </div>`;
                }

                return `
                                <div class="chat__message-file">
                                    <a href="${file.src}" download="${file.name}" target="_blank">
                                        <img src="../../img/file-icon.svg" alt="file" class="file-icon">
                                        <span>${file.name}</span>
                                    </a>
                                </div>`;
            }).join('')}
                    </div>` :
            ''
        }
                </div>
                ${!isCurrentUser ? `<img src="../../img/profile-pic-2.svg" alt="" class="profile-pic">` : ''}
            </div>
            <span class="chat__message-date-${isCurrentUser ? 'user' : 'manager'}">
                ${message.date}
            </span>
        `;

        messagesContainer.insertAdjacentHTML('beforeend', messageHTML);
    });

    // Добавляем обработчики для изображений
    const chatImages = document.querySelectorAll('.chat__message-image img');
    chatImages.forEach(img => {
        img.addEventListener('click', () => openImageModal(img.src));
    });

    scrollToBottom();
}

function sendMessage(text, chatId) {
    const formData = new FormData();
    formData.append('chatId', chatId);
    formData.append('text', text);
    formData.append('type', 'text');

    if (selectedFiles.length > 0) {
        selectedFiles.forEach((file, index) => {
            formData.append('files[]', file);
        });
    }

    fetch('/api/sendMessage.php', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(response => {
            console.log('Сообщение отправлено:', response);
            loadInitialMessages();
            resetInputs();
        })
        .catch(error => {
            console.error('Ошибка при отправке сообщения:', error);
        });
}

function resetInputs() {
    const input = document.querySelector('.chat__input input');
    const fileButton = document.querySelector('.chat__file-btn');
    input.value = '';
    selectedFiles = [];
    fileButton.textContent = '+';
}

function checkNewMessages() {
    if (!currentChatId) {
        console.error('chatId не определен');
        return;
    }

    return fetch(`/api/loadMessages.php?chatId=${currentChatId}`)
        .then(response => response.json())
        .then(response => {
            if (!response.data || !Array.isArray(response.data)) {
                console.error('Получены некорректные данные:', response);
                return;
            }

            if (response.data.length > chatMessages.length) {
                chatMessages = response.data;
                renderMessages(response.data);
            }
        })
        .catch(error => {
            console.error('Ошибка при проверке новых сообщений:', error);
        });
}

function scrollToBottom() {
    const messagesContainer = document.querySelector('.chat__messages');
    if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
}

function startAutoUpdate() {
    if (currentChatId) {
        updateInterval = setInterval(checkNewMessages, 15000);
    }
}

function stopAutoUpdate() {
    if (updateInterval) {
        clearInterval(updateInterval);
    }
}

// Add event listeners for error modal
document.addEventListener('DOMContentLoaded', () => {
    const okButton = document.querySelector('.chat-error-modal__ok');
    const modalOverlay = document.querySelector('.chat-error-modal__overlay');

    okButton.addEventListener('click', closeErrorModal);
    modalOverlay.addEventListener('click', closeErrorModal);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeErrorModal();
        }
    });
});

document.addEventListener('DOMContentLoaded', initChat);
window.addEventListener('beforeunload', stopAutoUpdate);